import {
  CardContent,
  CardHeader,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  CustomCard,
  LargeGridTexField,
  SmallGridTexField,
} from "./common-components";

export default function FaceVerificationForm(props) {
  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <CustomCard>
      <CardHeader title="Kết quả Face Verification" />
      <CardContent>
        <Grid container spacing={mobileScreen ? 1 : 1.75}>
          <LargeGridTexField
            label="Message"
            id="error_message"
            value={
              props.faceData.message ? props.faceData.message.error_message : ""
            }
          />
          <SmallGridTexField
            label="Trạng thái"
            id="face_anti_spoof_status"
            value={
              props.faceData.face_anti_spoof_status
                ? props.faceData.face_anti_spoof_status.status === "REAL"
                  ? `Ảnh mặt thật (score: ${1 - props.faceData.face_anti_spoof_status.fake_score})`
                  : `Ảnh có thể bị fake (score: ${1 - props.faceData.face_anti_spoof_status.fake_score})`
                : ""
            }
          />
          <SmallGridTexField
            label="Khẩu trang"
            id="wearing_mask"
            value={
              props.faceData.wearing_mask
                ? props.faceData.wearing_mask === "NO"
                  ? "Không đeo khẩu trang"
                  : "Đeo khẩu trang"
                : ""
            }
          />
          <SmallGridTexField
            label="Kết quả"
            id="result"
            value={
              props.faceData.verify_result === undefined
                ? ""
                : props.faceData.verify_result === 2
                ? "Cùng một người"
                : props.faceData.verify_result === 1
                ? "Có thể cùng một người"
                : "Không cùng một người"
            }
          />
          <SmallGridTexField
            label="Độ tương đồng"
            id="sim"
            value={props.faceData.sim || ""}
          />
        </Grid>
      </CardContent>
    </CustomCard>
  );
}
